
import React from "react";
import {connect, useSelector} from "react-redux";

import Joto from "../api/joto";
import * as jotoui from "../joto-ui-api";
import PropTypes from 'prop-types';

interface NavigationState {
    loggedIn: string | null;
}

interface NavigationProps extends NavigationState {
    joto: Joto
}

class NavLoginItem_ extends React.Component<NavigationProps,{}> {

    logxx = () => { 
        if(this.props.loggedIn)
            this.logout();
        else
            this.login();
    };

    logout = () => {
        this.props.joto.logout();
    };

    // https://stackoverflow.com/questions/25775862/return-a-value-from-window-open
    login = () => {
        this.props.joto.displayGuiLogin(window)
    };

    render() {
        const txt = this.props.loggedIn ? 'Logout' : 'Login';
        return <li className="nav-item active"><a className="nav-link" href="/#" onClick={this.logxx} style={{'width': '6em'}}>{txt}</a></li>;
    };
}

// @ts-ignore
NavLoginItem_.propTypes = {
    joto: PropTypes.object.isRequired,
};


const NavLoginItem_mapStateToProps = (state : jotoui.JotoUIState) : NavigationState => ({
    loggedIn: state.ui.loggedIn
}) ;

const NavLoginItem = connect(NavLoginItem_mapStateToProps)(NavLoginItem_);

// ReactDOM.render(<ReduxProvider store={store}><NavLoginItem/></ReduxProvider>, document.getElementById('nav-login-item'));

//type A = React.SFC;
function Navigation (props: React.PropsWithChildren<{joto: Joto}>) {

    const loggedIn = useSelector((state : jotoui.JotoUIState) : (string | null) => state.ui.loggedIn);
    const active = !loggedIn ? '' : 'active';
    const disabled = !loggedIn ? 'disabled' : '';
    // const style = {color : 'inherit', 'pointer-events': 'none'}
    const style = {};

    return <ul className="navbar-nav  w-100">
        {
            [
                <li key={1} className="mr-auto"/>,
                <li key={2} className="nav-item active"><a className="nav-link" href="/#" data-target="main-project-overview">Home</a></li>,
                <li key={4} className="nav-item active"><a className="nav-link" href="/#" data-target="search-projects">Projekte</a></li>,
                // <li key={5} className={"nav-item " + active} style={style}><a className={"nav-link " + disabled} href="/#" data-target="main-project">Projekt</a></li>,
                <li key={6} className={"nav-item " + active} style={style}><a className={"nav-link " + disabled} href="/#" data-target="main-profile">Profil</a></li>,
                <li key={3} className="nav-item active"><a className="nav-link" href="/#" data-target="main-about">Über Uns</a></li>,

                <NavLoginItem key={7} joto={props.joto}/>,
            ]
        }
    </ul>;
}

export {Navigation};
